(() => {
  const dialog = document.querySelector('[data-saved-drawer]');
  const configNode = document.querySelector('[data-saved-config]');
  if (!dialog || !configNode || !dialog.showModal || !window.fetch) return;
  const config = JSON.parse(configNode.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const list = dialog.querySelector('[data-saved-list]');
  const status = dialog.querySelector('[data-saved-status]');
  let handles = {};
  let saved = [];
  let generation = 0;
  let opener = null;
  try { const data = JSON.parse(localStorage.getItem('brusion-saved-object-handles') || '{}'); if (data && !Array.isArray(data) && typeof data === 'object') handles = data; } catch {}
  Object.assign(handles, config.handles);
  const ids = values => Array.isArray(values) ? [...new Set(values.map(String).filter(id => /^\d+$/.test(id)))].slice(0, 100) : [];
  try { saved = ids(JSON.parse(localStorage.getItem('brusion-saved-objects') || '[]')); } catch {}
  const remember = () => {
    document.querySelectorAll('[data-save-object][data-save-handle]').forEach(button => { handles[button.dataset.saveObject] = button.dataset.saveHandle; });
    const entries = Object.entries(handles).filter(([id, handle]) => saved.includes(id) && typeof handle === 'string' && handle.length <= 250);
    try { localStorage.setItem('brusion-saved-object-handles', JSON.stringify(Object.fromEntries(entries))); } catch {}
  };
  const counts = () => document.querySelectorAll('[data-saved-count]').forEach(node => {
    node.textContent = saved.length;
    node.hidden = saved.length === 0;
  });
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const load = async id => {
    const handle = handles[id];
    if (typeof handle !== 'string' || !handle) return { id, missing: true };
    try {
      const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000) });
      if (response.status === 404) return { id, missing: true };
      if (!response.ok) throw new Error();
      const product = await response.json();
      if (String(product.id) !== id || typeof product.title !== 'string') throw new Error();
      return { id, handle, product };
    } catch { return { id, failed: true }; }
  };
  const render = async () => {
    const token = ++generation;
    counts();
    remember();
    list.replaceChildren();
    status.classList.remove('b-saved-error');
    if (!saved.length) { status.textContent = config.empty; dialog.removeAttribute('aria-busy'); return; }
    status.textContent = config.loading;
    dialog.setAttribute('aria-busy', 'true');
    const current = [...saved];
    const results = new Array(current.length);
    let cursor = 0;
    await Promise.all(Array.from({ length: Math.min(3, current.length) }, async () => {
      while (cursor < current.length) { const index = cursor++; results[index] = await load(current[index]); }
    }));
    if (token !== generation || !dialog.open) return;
    const fragment = document.createDocumentFragment();
    let missing = false;
    let failed = false;
    for (const item of results) {
      const row = element('article', undefined, 'b-saved-item');
      const copy = element('div');
      if (item.product) {
        const product = item.product;
        const link = root + 'products/' + encodeURIComponent(item.handle);
        const pictureLink = element('a');
        pictureLink.href = link;
        pictureLink.tabIndex = -1;
        pictureLink.setAttribute('aria-hidden', 'true');
        const source = product.featured_image || product.images?.[0];
        if (typeof source === 'string' && source) {
          const image = document.createElement('img');
          const sourceUrl = new URL(source, location.origin);
          if (sourceUrl.protocol === 'https:' || sourceUrl.origin === location.origin) image.src = sourceUrl.href;
          image.alt = '';
          image.width = 90;
          image.height = 115;
          image.loading = 'lazy';
          pictureLink.append(image);
        }
        row.append(pictureLink);
        const titleLink = element('a');
        titleLink.href = link;
        titleLink.append(element('h3', product.title));
        copy.append(titleLink);
        const amount = Number(product.price) / 100;
        if (Number.isFinite(amount)) {
          let money;
          try { money = new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'USD', currencyDisplay: 'code' }).format(amount); }
          catch { money = amount.toFixed(2) + ' ' + (config.currency || 'USD'); }
          copy.append(element('p', money));
        }
        if (!product.available) copy.append(element('p', config.soldOut));
        const view = element('a', config.view + ' ↗', 'b-line-link');
        view.href = link;
        copy.append(view);
      } else {
        row.append(element('span'));
        copy.append(element('p', item.failed ? config.error : config.unavailable));
        failed ||= Boolean(item.failed);
        missing ||= Boolean(item.missing);
      }
      const remove = element('button', config.remove);
      remove.type = 'button';
      remove.dataset.removeSaved = item.id;
      copy.append(remove);
      row.append(copy);
      fragment.append(row);
    }
    list.replaceChildren(fragment);
    status.textContent = failed ? config.error : missing ? config.unavailable : '';
    status.classList.toggle('b-saved-error', failed);
    dialog.removeAttribute('aria-busy');
  };
  const open = trigger => {
    if (!dialog.open) { opener = trigger || document.activeElement; dialog.showModal(); }
    render();
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-saved-open]');
    if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) { event.preventDefault(); open(trigger); }
    if (event.target.closest('[data-saved-close]')) dialog.close();
    const remove = event.target.closest('[data-remove-saved]');
    if (remove) {
      document.dispatchEvent(new CustomEvent('brusion:remove-saved', { detail: { id: remove.dataset.removeSaved } }));
      dialog.querySelector('[data-saved-close]').focus();
    }
  });
  document.addEventListener('brusion:saved-changed', event => {
    saved = ids(event.detail?.saved);
    if (event.detail?.id && event.detail?.handle) handles[event.detail.id] = event.detail.handle;
    counts();
    remember();
    if (dialog.open) render();
  });
  dialog.addEventListener('close', () => { generation++; dialog.removeAttribute('aria-busy'); opener?.focus(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  remember();
  counts();
  if (new URLSearchParams(location.search).get('saved') === '1') open();
})();
